module.exports = __webpack_public_path__ + "img/xiaoman6.4eed5a9d.png";